import React from 'react';
import CalendarComponent from './components/Calendar';

function App() {
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="App" style={{ textAlign: 'center' }}>
      {!isMobile && <h3>Rink Calendar</h3>}
      <CalendarComponent />
    </div>
  );
}

export default App;
